import { ConceptType } from "@ha/data/basic";

export interface PermitPerson {
    birthDate: string;
    certificateId: number;
    certificateIdentifier: string;
    concept: ConceptType;
    email: string;
    expirationDate: string;
    hasValidCertificate: boolean;
    firstName: string;
    lastName: string;
    mobile: string;
    personId: number;
    personalNumber: string;
    hasForeignPersonalNumber: boolean;
    signature: PermitPersonSignature;
    endSignature: PermitPersonSignature;
    hasAcceptedUserAgreement: boolean;
    isPremiumIssuer: boolean;
    isPremiumSuperintendent: boolean;
    isFromColleague: boolean;
    isSharedFromPremium: boolean;
    allowExternalCertificates: boolean;
    isTextMember: boolean;
    textMemberId: number;
}

export interface PermitPersonSignature {
    date: string;
    guid: string;
    url: string;
}

export interface PermitPersonWithStatus extends PermitPerson {
    certificateExpired: boolean;
    certificateExpireSoon: boolean;
    canBeAdded: boolean;
}

export interface PermitPersonSubscription {
    id: number;
    name: string;
}

export enum RecentTeamMemberSort {
    lastUsed = 1,
    colleagues = 2,
    sharedFromPremium = 3,
    name = 4,
    certificateExpirationDate = 5,
}

export interface RecentTeamMembersResponse {
    members: PermitPerson[];
    hasColleagueMembers: boolean;
    hasSharedFromPremiumMembers: boolean;
    hasMore: boolean;
}
